import { Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbpModule } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { CalculationUsageStats, CommonLookupServiceProxy, UserLoginInfoDto } from '@shared/service-proxies/service-proxies';
import { UtilsModule } from '@shared/utils/utils.module';
import { CalculationService, PlanService } from 'services/project.service';
import { ModalPopupService } from '@app/main/cablepro/modal-popup.service';
import { LoaderService } from '@app/main/cablepro/loader.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Observable } from '@node_modules/rxjs';
import { appModuleAnimation } from '@shared/animations/routerTransition';

@Component({
  selector: 'app-trial-banner',
  templateUrl: './trial-banner.component.html',
  styleUrls: ['./trial-banner.component.css'],
  animations: [appModuleAnimation()],
  standalone: true,
  imports: [FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, RouterModule]
})
export class TrialBannerComponent extends AppComponentBase implements OnInit {

  public user?: UserLoginInfoDto;
  trialDaysLeft: number = 0;
  trialEndsText = '';
  public userStripePlanName: string = '';
  calculationUsageStats$!: Observable<CalculationUsageStats | null>;
  constructor(injector: Injector, private readonly _appSessionService: AppSessionService, private readonly _calculationService: CalculationService, private readonly _planService: PlanService, private readonly modalPopupService: ModalPopupService, private readonly loaderService: LoaderService, private readonly _commonLookupServiceProxy: CommonLookupServiceProxy) {
    super(injector);
    (window as any).trialBannerComponent = this;
    this.user = this._appSessionService.user;

    if (this.user) {
      if (this.user.isTrialing && this.user.trialEndDate) {
        const today = new Date();
        const trialEnd = new Date(this.user.trialEndDate);
        const diffTime = trialEnd.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert ms → days
        this.trialDaysLeft = Math.max(diffDays, 0); // never negative
        this.trialEndsText = this.getTrialEndsText(this.user.trialEndDate);
        this.userStripePlanName = this.getLatestPlanName(this.user.userStripePlanLevel) + ' - Free Trial';
      } else {
        this.trialDaysLeft = 0;
        this.trialEndsText = this.getTrialEndsText(this.user.trialEndDate);
        this.userStripePlanName = this.getLatestPlanName(this.user.userStripePlanLevel) + ' - Free Trial';
      }
    }
  }

  ngOnInit() {
    this.calculationUsageStats$ = this._calculationService.calculationUsage$;
  }

  SkipTrial() {
    this.onSkipTrial(this.loaderService, this._planService, this._commonLookupServiceProxy);
  }

  getDllUsageProgressColor(usage: CalculationUsageStats): string {
    const percent = (usage.dllCallUsed / usage.dllCallLimit) * 100;

    if (percent < 55) {
      return 'm--bg-brand';   // green
    } else if (percent < 85) {
      return 'bg-warning';   // yellow
    } else {
      return 'bg-danger';    // red
    }
  }

  private getTrialEndsText(trialEndDate: string | Date): string {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const trialEnd = new Date(trialEndDate);
    trialEnd.setHours(0, 0, 0, 0);

    const diffDays =
      Math.round((trialEnd.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Ends today';
    }

    if (diffDays === 1) {
      return 'Ends tomorrow';
    }

    return `${diffDays} days left`;
  }

}
